import { render, staticRenderFns } from "./DuplicateLeadsReport.vue?vue&type=template&id=39ca3862&scoped=true"
import script from "./DuplicateLeadsReport.vue?vue&type=script&lang=js"
export * from "./DuplicateLeadsReport.vue?vue&type=script&lang=js"
import style0 from "./DuplicateLeadsReport.vue?vue&type=style&index=0&id=39ca3862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca3862",
  null
  
)

export default component.exports